import axios from 'axios'

const searchApiUrl = "/api/news"


const newsResultEl = jQuery('#news_result_box')
const newsLoadMoreBtn = jQuery('#news_load_more_btn')
const newsLoadMoreLoader = jQuery('#news_load_more_loader')


function newsTeasetTemplate(url, img, title, text, read_more) {

    let template = `
        <article class="content-teaser">
            <div class="content-teaser--col image-col">
                <a href="${url}">
                    <img class="logo-gold-img" src="${img}" alt="${title}">
                </a>
            </div>
            <div class="content-teaser--col text-col ">
                <a href="${url}">
                    <h3 class="content-teaser--title text-tag text_white">${title}</h3>
                </a>
                <div class="text-small content-teaser--desc">
                    ${text}
                </div>
                <div class="content-teaser--link-box">
                    <a class="content-teaser--link  card-cta-link text_rockstar_gold" href="${url}">${read_more} +</a>
                </div>
            </div>
        </article>
    `
    return template
}

let state = {
    is_loading: false,
    page: 2,
    posts_per_page: 3,
    total_posts: 0
}


function setLoading(isLoading) {
    state.is_loading = isLoading

    if (isLoading) {
        newsLoadMoreLoader.show()
        newsLoadMoreBtn.hide()
    } else {
        newsLoadMoreLoader.hide()
        newsLoadMoreBtn.show()

    }
}


function setPage(page) {
    state.page = page
}

function setPostPerPage(postCount) {
    state.posts_per_page = postCount
}

function setTotalPost(postCount) {
    state.total_posts = postCount
}


function addPosts(postList) {
    const lastScrollHeight = window.scrollY;
    if (isLastPage()) {
        newsLoadMoreBtn.remove()
    }

    for (var i = 0; i < postList.length; i++) {
        const post = postList[i]
        newsResultEl.append(newsTeasetTemplate(post.postUrl, post.image, post.title, post.text, post.read_more))
    }

    // Set previous scroll position
    document.documentElement.scrollTop = lastScrollHeight;

    setPage(state.page + 1)
}

function isLastPage() {
    let isLast = false
    if ((state.posts_per_page * state.page) < state.total_posts) {
        isLast = false
    } else {
        isLast = true
    }
    return isLast
}


function getNewsPosts() {
    setLoading(true)
    axios
        .post(searchApiUrl, {
            keys: state.keys, page: state.page, posts_per_page: state.posts_per_page,
        })
        .then(function (response) {
            const data = response.data;
            setTotalPost(data.total_posts)
            setPostPerPage(data.posts_per_page)
            setPage(data.page)
            addPosts(data.posts)
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        .then(function () {
            // always executed
            setTimeout(function () {
                setLoading(false)
            }, 200)
        });
}


if (newsLoadMoreBtn.length) {
    newsLoadMoreBtn.on('click', getNewsPosts)
}
